import { default as globals } from "../base/_globals.js";

const body = document.querySelector("body");
const mobileMenuButton = document.getElementById("main_nav_button");
const mainNav = document.getElementById("main_nav");
const scrollBox = document.getElementById("nav_scroll");
const skip_nav_link = document.getElementById("skip_nav_link");
let listItemsWithChildren = null;

/**
 *
 *
 *
 */
const init = function () {
	if (mainNav !== null) {
		listItemsWithChildren = mainNav.querySelectorAll(".menu-item-has-children");

		setupDesktopSubmenuToggling();
		setupMobileMenuEventListeners();
		setupMobileSubmenuButtons();
	}
};

/**
 *
 *
 *
 */
const checkBodyForVisibilityClass = function () {
	if (body.classList.contains("mobile-menu-visible")) {
		toggleMobileMenu("hide");
	} else {
		toggleMobileMenu("show");
	}
};

/**
 * Shows or hides the mobile by modifying classes & aria
 * attributes.
 *
 * @param state String "Show" to show the menu, anything else to hide
 * @return none
 *
 */
const toggleMobileMenu = function (state) {
	var bodyActiveClass = "mobile-menu-visible";
	var menuActiveClass = "is-active";

	if (state === "show") {
		body.classList.add(bodyActiveClass);
		mobileMenuButton.classList.add(menuActiveClass);
		mobileMenuButton.setAttribute("aria-expanded", "true");
		mainNav.removeAttribute("hidden");
	} else {
		body.classList.remove(bodyActiveClass);
		mobileMenuButton.classList.remove(menuActiveClass);
		mobileMenuButton.setAttribute("aria-expanded", "false");
		mainNav.setAttribute("hidden", "hidden");

		// return the menu to the top so that when the user opens
		// it again it doesn't return a scrolled state
		scrollBox.scrollTop = 0;
	}
};

/**
 * Sets up event listeners for showing/hiding the main menu
 * in its mobile format. These event listeners work hand-in-hand
 * to hide the menu when it loses focus or when something outside
 * the menu has been clicked.
 *
 * @param none
 * @return nothing
 *
 */
const setupMobileMenuEventListeners = function () {
	mobileMenuButton.addEventListener("click", checkBodyForVisibilityClass);

	// if user clicks the skip nav link then we'll want to close
	// the menu if it's open
	if (skip_nav_link !== null) {
		skip_nav_link.addEventListener("click", function () {
			toggleMobileMenu("hide");
		});
	}

	// on click and focusin
	["click", "focusin"].forEach(function (ev) {
		body.addEventListener(
			ev,
			function () {
				// if below menu breakpoint
				if (window.innerWidth < globals.breakpoint) {
					toggleMobileMenu("hide");
				}
			},
			false
		);

		// prevent event propagation
		mobileMenuButton.addEventListener(
			ev,
			function (ev) {
				ev.stopPropagation();
			},
			false
		);

		// prevent event propagation
		mainNav.addEventListener(
			ev,
			function (ev) {
				ev.stopPropagation();
			},
			false
		);
	});

	// Escape key closes menu
	window.addEventListener(
		"keyup",
		e => {
			if (e.key === "Escape" || e.key === "Esc") {
				// deprecated: e.keyCode === 27
				toggleMobileMenu("hide");
				e.preventDefault();
				return false;
			}
		},
		true
	);
};

/**
 * Adds a button to expand and contract submenus on small screens
 */
const setupMobileSubmenuButtons = function () {
	Array.prototype.forEach.call(listItemsWithChildren, el => {
		const parent_id = el.getAttribute("id");
		const parent_a = el.querySelector("a");
		const parent_text = parent_a.textContent;
		const submenu = el.querySelector(".sub-menu");
		const submenu_id = submenu.getAttribute("id");
		const button_id = parent_id + "_button";
		const button = document.createElement("button");

		button.innerHTML = parent_text;
		button.setAttribute("id", button_id);
		button.setAttribute("aria-expanded", "false");
		button.setAttribute("aria-label", "menu");
		button.setAttribute("aria-controls", submenu_id);
		button.setAttribute("class", "menu-item__submenu-button");

		el.insertBefore(button, submenu);

		button.addEventListener("click", () => {
			// hide the submenu
			if (el.classList.contains("sub-menu-visible")) {
				submenu.setAttribute("aria-hidden", "true");
				button.setAttribute("aria-expanded", "false");
				el.classList.remove("sub-menu-visible");

				// show the submenu
			} else {
				submenu.setAttribute("aria-hidden", "false");
				button.setAttribute("aria-expanded", "true");
				el.classList.add("sub-menu-visible");
			}
		});
	});
};

/**
 * Sets up the event listeners, class and aria attribute toggling for
 * the desktop submenus.
 *
 * @param none
 * @return nothing
 *
 */
const setupDesktopSubmenuToggling = function () {
	Array.prototype.forEach.call(listItemsWithChildren, el => {
		const parent_id = el.getAttribute("id");
		const submenu = el.querySelector(".sub-menu");
		const submenu_id = parent_id + "_submenu";

		// const link = el.firstChild;
		// link.setAttribute('aria-haspopup', 'true');

		submenu.setAttribute("aria-hidden", "true");
		submenu.setAttribute("id", submenu_id);

		["mouseover", "focusin"].forEach(ev => {
			el.addEventListener(ev, function () {
				// make sure we're not below the mobile breakpoint
				if (
					submenu.getAttribute("aria-hidden") === "true" &&
					window.innerWidth >= globals.breakpoint
				) {
					submenu.setAttribute("aria-hidden", "false");
					el.classList.add("sub-menu-visible");
				}
			});
		});

		el.addEventListener("mouseout", () => {
			// make sure we're not below the mobile breakpoint
			if (window.innerWidth >= globals.breakpoint) {
				submenu.setAttribute("aria-hidden", "true");
				el.classList.remove("sub-menu-visible");
			}
		});

		el.addEventListener("focusout", e => {
			// make sure we're not below the mobile breakpoint
			if (
				!el.contains(e.relatedTarget) &&
				window.innerWidth >= globals.breakpoint
			) {
				submenu.setAttribute("aria-hidden", "true");
				el.classList.remove("sub-menu-visible");
			}
		});
	});
};

/**
 * Loops through the menu items with children and REMOVES the aria-haspopup
 * attribute since the link will not have a hover effect on mobile to display
 * the submenu.
 *
 * @param none
 * @return nothing
 *
 */
const mobileMode = function () {
	// loop through the submenu parents and remove the aria-haspopup attribute
	Array.prototype.forEach.call(listItemsWithChildren, el => {
		const link = el.firstChild;
		link.removeAttribute("aria-haspopup");
	});
};

/**
 * Loops through the menu items with children and ADDS the aria-haspopup
 * attribute since the link will has a hover effect on desktop to display
 * the submenu. Also sets corresponding aria-hidden attribute on the submenu
 * to true, and adds a class to the parent list item that's used to display
 * the submenu.
 *
 * @param none
 * @return nothing
 *
 */
const desktopMode = function () {
	if (listItemsWithChildren !== null) {
		Array.prototype.forEach.call(listItemsWithChildren, el => {
			const link = el.firstChild;
			const submenu = el.querySelector(".sub-menu");

			// add the aria-haspopup attribute
			link.setAttribute("aria-haspopup", "true");
			el.classList.remove("sub-menu-visible");
			submenu.setAttribute("aria-hidden", "true");
		});
	}
};

const api = {
	init: init,
	mobileMode: mobileMode,
	desktopMode: desktopMode
};

export default api;
